import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import _createForOfIteratorHelper from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.object.values";
import messageApi from '@/api/WMS/message.js';
import { Notification } from 'element-ui'; // 引入 Notification

var state = {
  messageTimer: null,
  localMessageCounts: {},
  tabsConfig: [{
    name: 'finance',
    label: '财务消息',
    apiEndpoint: '1'
  }, {
    name: 'stock',
    label: '库存消息',
    apiEndpoint: '2'
  }, {
    name: 'system',
    label: '系统消息',
    apiEndpoint: '4'
  }],
  isInitialized: false,
  // 添加初始化标记
  notificationsEnabled: true,
  // 添加通知开关状态
  recentMessages: [] // 添加最近消息列表
};

var mutations = {
  SET_MESSAGE_TIMER: function SET_MESSAGE_TIMER(state, timer) {
    state.messageTimer = timer;
  },
  SET_MESSAGE_COUNTS: function SET_MESSAGE_COUNTS(state, counts) {
    state.localMessageCounts = counts;
  },
  SET_TABS_CONFIG: function SET_TABS_CONFIG(state, config) {
    state.tabsConfig = config;
  },
  SET_INITIALIZED: function SET_INITIALIZED(state, value) {
    // 添加设置初始化状态的 mutation
    state.isInitialized = value;
  },
  SET_NOTIFICATIONS_ENABLED: function SET_NOTIFICATIONS_ENABLED(state, enabled) {
    state.notificationsEnabled = enabled;
  },
  SET_RECENT_MESSAGES: function SET_RECENT_MESSAGES(state, messages) {
    state.recentMessages = messages;
  }
};

// 添加getters
var getters = {
  totalUnreadMessages: function totalUnreadMessages(state) {
    return Object.values(state.localMessageCounts).reduce(function (total, count) {
      return total + count;
    }, 0);
  }
};
var actions = {
  // 添加初始化消息数量的 action
  initMessageCounts: function () {
    var _initMessageCounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
      var commit, state, dispatch, counts, userData, messageTimestamp, _iterator, _step, tab, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref.commit, state = _ref.state, dispatch = _ref.dispatch;
            if (!state.isInitialized) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.prev = 3;
            counts = {};
            userData = JSON.parse(window.sessionStorage.getItem('USER_DATA')) || {};
            messageTimestamp = userData.messageTimestamp || userData.loginTime; // 如果没有获取到 loginTime，显示提示并触发退出登录
            if (userData.loginTime) {
              _context2.next = 11;
              break;
            }
            Notification({
              title: '登录状态异常',
              message: '您的登录状态已失效，请重新登录',
              type: 'error',
              duration: 3000,
              position: 'top-right',
              showClose: true
            });

            // 延迟一下退出登录，让用户能看到提示
            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return dispatch('user/logout', null, {
                      root: true
                    });
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), 1000);
            return _context2.abrupt("return");
          case 11:
            _iterator = _createForOfIteratorHelper(state.tabsConfig);
            _context2.prev = 12;
            _iterator.s();
          case 14:
            if ((_step = _iterator.n()).done) {
              _context2.next = 28;
              break;
            }
            tab = _step.value;
            _context2.prev = 16;
            _context2.next = 19;
            return messageApi.homeMessageCount(tab.apiEndpoint, 0, messageTimestamp);
          case 19:
            response = _context2.sent;
            if (response.code === 200) {
              counts[tab.name] = Number(response.data) || 0;
            } else {
              counts[tab.name] = 0;
            }
            _context2.next = 26;
            break;
          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](16);
            counts[tab.name] = 0;
          case 26:
            _context2.next = 14;
            break;
          case 28:
            _context2.next = 33;
            break;
          case 30:
            _context2.prev = 30;
            _context2.t1 = _context2["catch"](12);
            _iterator.e(_context2.t1);
          case 33:
            _context2.prev = 33;
            _iterator.f();
            return _context2.finish(33);
          case 36:
            commit('SET_MESSAGE_COUNTS', counts);
            commit('SET_INITIALIZED', true); // 标记为已初始化

            // 同时获取最近的消息
            dispatch('fetchRecentMessages');
            _context2.next = 44;
            break;
          case 41:
            _context2.prev = 41;
            _context2.t2 = _context2["catch"](3);
            console.error('初始化消息数量失败:', _context2.t2);
          case 44:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 41], [12, 30, 33, 36], [16, 23]]);
    }));
    function initMessageCounts(_x) {
      return _initMessageCounts.apply(this, arguments);
    }
    return initMessageCounts;
  }(),
  // 获取最近的消息
  fetchRecentMessages: function () {
    var _fetchRecentMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
      var commit, response, formattedMessages;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.prev = 1;
            _context3.next = 4;
            return messageApi.homeTop10Message();
          case 4:
            response = _context3.sent;
            if (response.code === 200 && Array.isArray(response.data)) {
              formattedMessages = response.data.map(function (item) {
                return {
                  messageDate: item.messageDate || '',
                  messageTitle: item.messageTitle || '无标题',
                  messageKey: item.messageKey || "msg-".concat(Date.now(), "-").concat(Math.random()),
                  messageContent: item.messageContent || '',
                  status: Number(item.status) || 0,
                  type: item.messageBossiness || '1',
                  // 消息类型：1=财务消息，2=库存消息，4=系统消息
                  typeName: getMessageTypeName(item.messageBossiness || '1')
                };
              });
              commit('SET_RECENT_MESSAGES', formattedMessages);
            }
            _context3.next = 12;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            console.error('获取最近消息失败:', _context3.t0);
            commit('SET_RECENT_MESSAGES', []);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 8]]);
    }));
    function fetchRecentMessages(_x2) {
      return _fetchRecentMessages.apply(this, arguments);
    }
    return fetchRecentMessages;
  }(),
  startMessageTimer: function startMessageTimer(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
    if (state.messageTimer) {
      clearInterval(state.messageTimer);
    }
    var timer = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var counts, userData, messageTimestamp, _iterator2, _step2, tab, response, currentCount, newCount, currentTime, updatedUserData;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            counts = {};
            userData = JSON.parse(window.sessionStorage.getItem('USER_DATA')) || {};
            messageTimestamp = userData.messageTimestamp || userData.loginTime; // 如果没有获取到 messageTimestamp，显示提示并触发退出登录
            if (messageTimestamp) {
              _context5.next = 8;
              break;
            }
            Notification({
              title: '登录状态异常',
              message: '您的登录状态已失效，请重新登录',
              type: 'error',
              duration: 3000,
              position: 'top-right',
              showClose: true
            });

            // 延迟一下退出登录，让用户能看到提示
            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return dispatch('user/logout', null, {
                      root: true
                    });
                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            })), 1000);
            return _context5.abrupt("return");
          case 8:
            _iterator2 = _createForOfIteratorHelper(state.tabsConfig);
            _context5.prev = 9;
            _iterator2.s();
          case 11:
            if ((_step2 = _iterator2.n()).done) {
              _context5.next = 25;
              break;
            }
            tab = _step2.value;
            _context5.prev = 13;
            _context5.next = 16;
            return messageApi.homeMessageCount(tab.apiEndpoint, 1, messageTimestamp);
          case 16:
            response = _context5.sent;
            if (response.code === 200) {
              currentCount = state.localMessageCounts[tab.name] || 0;
              newCount = Number(response.data) || 0;
              counts[tab.name] = currentCount + newCount;

              // 只在通知开启时显示提醒
              if (newCount > 0 && state.notificationsEnabled) {
                Notification({
                  title: '新消息提醒',
                  type: 'success',
                  duration: 4000,
                  position: 'top-right',
                  showClose: true,
                  dangerouslyUseHTMLString: true,
                  message: "<strong>".concat(tab.label, "</strong> \u6709 <span style=\"color: #67C23A; font-weight: bold;\">").concat(newCount, "</span> \u6761\u65B0\u6D88\u606F")
                });
                currentTime = new Date().getTime();
                updatedUserData = _objectSpread(_objectSpread({}, userData), {}, {
                  messageTimestamp: currentTime
                });
                window.sessionStorage.setItem('USER_DATA', JSON.stringify(updatedUserData));
                messageTimestamp = currentTime;

                // 有新消息时，刷新最近消息列表
                dispatch('fetchRecentMessages');
              }
            } else {
              counts[tab.name] = state.localMessageCounts[tab.name] || 0;
            }
            _context5.next = 23;
            break;
          case 20:
            _context5.prev = 20;
            _context5.t0 = _context5["catch"](13);
            counts[tab.name] = state.localMessageCounts[tab.name] || 0;
          case 23:
            _context5.next = 11;
            break;
          case 25:
            _context5.next = 30;
            break;
          case 27:
            _context5.prev = 27;
            _context5.t1 = _context5["catch"](9);
            _iterator2.e(_context5.t1);
          case 30:
            _context5.prev = 30;
            _iterator2.f();
            return _context5.finish(30);
          case 33:
            commit('SET_MESSAGE_COUNTS', counts);
            _context5.next = 39;
            break;
          case 36:
            _context5.prev = 36;
            _context5.t2 = _context5["catch"](0);
            console.error('获取消息数量失败:', _context5.t2);
          case 39:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 36], [9, 27, 30, 33], [13, 20]]);
    })), 1800000); // 1800000毫秒 (30分钟)

    commit('SET_MESSAGE_TIMER', timer);
  },
  stopMessageTimer: function stopMessageTimer(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state;
    if (state.messageTimer) {
      clearInterval(state.messageTimer);
      commit('SET_MESSAGE_TIMER', null);
    }
  },
  // 添加设置 tabsConfig 的 action
  setTabsConfig: function setTabsConfig(_ref8, config) {
    var commit = _ref8.commit;
    commit('SET_TABS_CONFIG', config);
  },
  // 添加重置初始化状态的 action，用于登出时调用
  resetMessageState: function resetMessageState(_ref9) {
    var commit = _ref9.commit;
    commit('SET_MESSAGE_COUNTS', {});
    commit('SET_INITIALIZED', false);
    commit('SET_RECENT_MESSAGES', []);
  },
  // 添加切换通知状态的 action
  toggleNotifications: function toggleNotifications(_ref10) {
    var commit = _ref10.commit,
      state = _ref10.state;
    commit('SET_NOTIFICATIONS_ENABLED', !state.notificationsEnabled);
  },
  // 标记消息为已读
  markMessageAsRead: function () {
    var _markMessageAsRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref11, messageKey) {
      var commit, state, dispatch, updatedMessages;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref11.commit, state = _ref11.state, dispatch = _ref11.dispatch;
            _context6.prev = 1;
            _context6.next = 4;
            return messageApi.readMessage(messageKey);
          case 4:
            // 更新最近消息列表中的消息状态
            updatedMessages = state.recentMessages.map(function (msg) {
              if (msg.messageKey === messageKey) {
                return _objectSpread(_objectSpread({}, msg), {}, {
                  status: 1
                });
              }
              return msg;
            });
            commit('SET_RECENT_MESSAGES', updatedMessages);

            // 重新获取消息数量
            dispatch('initMessageCounts');
            _context6.next = 12;
            break;
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](1);
            console.error('标记消息已读失败:', _context6.t0);
          case 12:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[1, 9]]);
    }));
    function markMessageAsRead(_x3, _x4) {
      return _markMessageAsRead.apply(this, arguments);
    }
    return markMessageAsRead;
  }()
};

// 辅助函数：根据消息类型获取类型名称
function getMessageTypeName(type) {
  var typeMap = {
    '1': '财务消息',
    '2': '库存消息',
    '4': '系统消息'
  };
  return typeMap[type] || '其他消息';
}
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};